// extracted by mini-css-extract-plugin
module.exports = {"showTrigger":"HistoryRecords_showTrigger__3Z6rR","allCurtain":"HistoryRecords_allCurtain__2-2h-"};